import RankSeven from '@assets/icons/rank-seven.svg'
import { Icon } from './Icon'

export const RankSevenIcon = Icon(RankSeven)
